
import { SERVICES } from '../../constants/services';
import { env } from "../../environments/environment";
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { FilterModel } from '../../models/FilterModel';
import { UserModel } from '../../models/UserModel';
import { AlertController, Platform, Events, LoadingController, ModalController } from "@ionic/angular";
import { TranslateService } from '@ngx-translate/core';
import { CombeniaSyncService } from '../CombeniaService/CombeniaSyncService';
import { LoadingService } from '../loading.service';
import { AlertComponent } from 'src/app/components/alert/alert.component';
@Injectable()
export class BackendDataService {

  public sectionId: string;

  public semaforoError = false;



  constructor(
    private http: HttpClient,
    private loadCtrl: LoadingController,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private sync: CombeniaSyncService,
    private loadingService: LoadingService,
    private modalController: ModalController,
    private events: Events
  ) { }

  ngOnInit() { }

  async showError(message) {
    const alert = await this.modalController.create({
      component: AlertComponent,
      cssClass: "my-popover-alert",
      componentProps: {
        title: this.translateService.instant('ERROR').toUpperCase(),
        message: message,
        outlineButtonConfirm: false,
        onlyConfirm: true,
        buttonCancel: this.translateService.instant('CANCEL'),
        buttonConfirm: this.translateService.instant('OK')
      }
    });
    await alert.present();
  }


  getExportUrl() {
    if (!SERVICES[this.sectionId] || !SERVICES[this.sectionId].export)
      return "";
    return env.serviceUrl + "/" + SERVICES[this.sectionId].export;
  }

  get(serviceUrl): Promise<any> {

    let url = env.serviceUrl + "/" + serviceUrl
    return new Promise((resolve, reject) => {
      let request = this.http
        .get(
          url,
          {
            headers: { "Accept": "*/*", "Content-Type": "application/json", 'Authorization': `Basic ` + btoa('kevsuser:Kvs2020!') }
          },
        )
        .subscribe(
          (success: any) => {
            resolve(success);
          },
          (error: any) => {
            this.manageError(error, serviceUrl);
            reject(error);
          },
          () => {
            request.unsubscribe();
          }
        );
    });
  }
  getExcel(serviceUrl, filename): Promise<any> {

    let url = env.serviceUrl + "/" + serviceUrl
    return new Promise((resolve, reject) => {
      let request = this.http
        .get(
          url,
          {
            headers: { "Accept": "*/*", "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 'Authorization': `Basic ` + btoa('kevsuser:Kvs2020!') },
            // to explicitly give as 'boby'as http client by default give res.json()
            observe: 'response' as 'body',

            // have to explicitly give as 'blob' or 'json'
            responseType: 'blob' as 'json'
          },
        )
        .subscribe(
          (success: any) => {
            this.downLoadFile(success, filename);
            resolve(success);
          },
          (error: any) => {
            this.manageError(error, serviceUrl);
            reject(error);
          },
          () => {
            request.unsubscribe();
          }
        );
    });
  }
  downLoadFile(response: any, filename) {
    let dataType = response.body.type;
    let binaryData = [];
    binaryData.push(response.body);
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));

    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    return true;
  }
  delete(serviceUrl): Promise<any> {

    let url = env.serviceUrl + "/" + serviceUrl
    return new Promise((resolve, reject) => {
      let request = this.http
        .delete(
          url,
          {
            headers: { "Accept": "*/*", "Content-Type": "application/json", 'Authorization': `Basic ` + btoa('kevsuser:Kvs2020!') }
          },
        )
        .subscribe(
          (success: any) => {
            resolve(success);
          },
          (error: any) => {
            this.manageError(error, serviceUrl);
            reject(error);
          },
          () => {
            request.unsubscribe();
          }
        );
    });
  }

  manageError(error, serviceUrl) {
    if (this.semaforoError)
      return;
    this.semaforoError = true;
    setTimeout(() => {
      this.semaforoError = false;
    }, 1000)
    var message = `[${error.status}] ` + this.translateService.instant('ERROR_OCCURRED') + ` (Service: ${serviceUrl})`;
    if (error.status == 0)
      message = this.translateService.instant('ERROR_CONNECTION_OCCURRED')
    this.showError(message);
  }

  request(serviceUrl, filter, notShowingError = false): Promise<any> {

    let url = env.serviceUrl + "/" + serviceUrl
    return new Promise((resolve, reject) => {
      let request = this.http
        .post(
          url,
          filter,
          {
            headers: { "Accept": "*/*", "Content-Type": "application/json", 'Authorization': `Basic ` + btoa('kevsuser:Kvs2020!') }
          },
        )
        .subscribe(
          (success: any) => {
            resolve(success);
          },
          (error: any) => {

            if (!notShowingError) {
              this.manageError(error, serviceUrl);
            }



            reject(error);
          },
          () => {
            request.unsubscribe();
          }
        );
    });
  }

  import(serviceUrl, file, params) {
    let url = env.serviceUrl + "/" + serviceUrl;
    return new Promise((resolve, reject) => {


      let body = new FormData();
      body.append('file', file, file['name']);
      for (let key in params) {
        body.append(key, params[key]);
      }

      let request = this.http
        .post(
          url,
          body,
          {}
        )
        .subscribe(
          success => {
            resolve(success);
          },
          (error: any) => {
            this.manageError(error, url);
            resolve(null);
          },
          () => {
            request.unsubscribe();
          }
        );
    });
  }


  getImageUrl(element, imageFomForAll?) {
    if (element.images && element.images.cat) {
      if (element.images.cat.xxl && element.images.cat.xxl.filename)
        element.images.cat.xxl.filename = env.imageUrl + element.images.cat.xxl.filename;
      if (element.images.cat.s && element.images.cat.s.filename)
        element.images.cat.s.filename = env.imageUrl + element.images.cat.s.filename;
      if (element.images.cat.xs && element.images.cat.xs.filename)
        element.images.cat.xs.filename = env.imageUrl + element.images.cat.xs.filename;
    }
    if (element.images && element.images.front) {
      if (element.images.front.xxl && element.images.front.xxl.filename) {
        element.images.front.xxl.filename = env.imageUrl + element.images.front.xxl.filename;
      }
      if (element.images.front.s && element.images.front.s.filename) {
        element.images.front.s.filename = env.imageUrl + element.images.front.s.filename;
      }
      if (element.images.front.xs && element.images.front.xs.filename) {
        element.images.front.xs.filename = env.imageUrl + element.images.front.xs.filename;
      }
    }
    if (element.images && element.images.lat) {
      if (element.images.lat.xxl && element.images.lat.xxl.filename) {
        element.images.lat.xxl.filename = env.imageUrl + element.images.lat.xxl.filename;
      }
      if (element.images.lat.s && element.images.lat.s.filename) {
        element.images.lat.s.filename = env.imageUrl + element.images.lat.s.filename;
      }
      if (element.images.lat.xs && element.images.lat.xs.filename) {
        element.images.lat.xs.filename = env.imageUrl + element.images.lat.xs.filename;
      }
    }
    if (imageFomForAll) {
      if (imageFomForAll.fom) {
        if (imageFomForAll.fom.s && imageFomForAll.fom.s.filename) {
          element.images.fom.s.filename = env.imageUrl + imageFomForAll.fom.s.filename
        }
        if (imageFomForAll.fom.xs && imageFomForAll.fom.xs.filename) {
          element.images.fom.xs.filename = env.imageUrl + imageFomForAll.fom.xs.filename
        }
        if (imageFomForAll.fom.xxl && imageFomForAll.fom.xxl.filename) {
          element.images.fom.xxl.filename = env.imageUrl + imageFomForAll.fom.xxl.filename
        }
      }
    } else {
      if (element.images && element.images.fom) {
        if (element.images.fom.xxl && element.images.fom.xxl.filename)
          element.images.fom.xxl.filename = env.imageUrl + element.images.fom.xxl.filename;
        if (element.images.fom.s && element.images.fom.s.filename)
          element.images.fom.s.filename = env.imageUrl + element.images.fom.s.filename;
      }
    }
  }


  setSmallImage(article) {
    let smallImage = "";
    if (article.images && article.images.cat && article.images.cat.xxl && article.images.cat.xxl.filename) {
      smallImage = article.images.cat.xxl.filename;
    } else if (article.images && article.images.cat && article.images.cat.s && article.images.cat.s.filename) {
      smallImage = article.images.cat.s.filename;
    } else if (article.images && article.images.cat && article.images.cat.xs && article.images.cat.xs.filename) {
      smallImage = article.images.cat.xs.filename;
    } else if (article.images && article.images.front && article.images.front.xxl && article.images.front.xxl.filename) {
      smallImage = article.images.front.xxl.filename;
    } else if (article.images && article.images.front && article.images.front.s && article.images.front.s.filename) {
      smallImage = article.images.front.s.filename;
    } else if (article.images && article.images.front && article.images.front.xs && article.images.front.xs.filename) {
      smallImage = article.images.front.xs.filename;
    }
    // } else if(article.images && article.images.fom && article.images.fom.xxl && article.images.fom.xxl.filename) {
    //   smallImage = article.images.fom.xxl.filename;
    // } else if(article.images && article.images.fom && article.images.fom.s && article.images.fom.s.filename) {
    //   smallImage = article.images.fom.s.filename;
    // } else if(article.images && article.images.fom && article.images.fom.xs && article.images.fom.xs.filename) {
    //   smallImage = article.images.fom.xs.filename;
    // } COMMENTATE RICHIESTA SPINA
    else {
      smallImage = "assets/image/no_image.png";
    }
    return smallImage;
  }





}
